// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
    display: block;
}

/* Layout shell */
.user-guide-layout {
    display: flex;
    background: #f4f6f9;
}

/* Sidebar */
.user-guide-sidebar {
    display: flex;
    flex-direction: column;
    width: 260px;
    min-width: 260px;
    background: #1e2a3a;
    color: #d6e0ed;
    box-shadow: 2px 0 8px rgba(0, 0, 0, 0.18);
    flex-shrink: 0;
}

.sidebar-header {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 18px 12px 14px;
    border-bottom: 1px solid rgba(255, 255, 255, 0.1);
    background: rgba(0, 0, 0, 0.2);
    white-space: nowrap;
    overflow: hidden;
}

.sidebar-header-icon {
    color: #6fb3f5;
    font-size: 22px;
    flex-shrink: 0;
}

.sidebar-header-title {
    flex: 1;
    font-size: 0.85rem;
    font-weight: 700;
    letter-spacing: 0.06em;
    text-transform: uppercase;
    color: #ffffff;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

/* Sidebar nav */
.sidebar-nav {
    flex: 1;
    overflow-y: auto;
    overflow-x: hidden;
    padding: 8px 0;
}

.sidebar-nav::-webkit-scrollbar {
    width: 4px;
}

.sidebar-nav::-webkit-scrollbar-thumb {
    background: rgba(255, 255, 255, 0.15);
    border-radius: 2px;
}

.sidebar-nav-item {
    display: flex;
    align-items: center;
    width: 100%;
    padding: 11px 14px;
    background: none;
    border: none;
    border-left: 3px solid transparent;
    cursor: pointer;
    color: #d6e0ed;
    text-align: left;
    white-space: nowrap;
    overflow: hidden;
    transition: background 0.22s ease, color 0.22s ease;
}

.sidebar-nav-item:hover {
    background: rgba(255, 255, 255, 0.07);
    color: #ffffff;
}

.sidebar-nav-item.active {
    background: rgba(0, 85, 179, 0.35);
    border-left-color: #0055b3;
    color: #ffffff;
}

.sidebar-nav-label {
    font-size: 0.875rem;
    line-height: 1.35;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

/* Content panel */
.user-guide-content {
    flex: 1;
    padding: 32px 40px;
    background: #f4f6f9;
    min-width: 0;
}

@media (max-width: 768px) {
    .user-guide-content {
        padding: 20px 16px;
    }
}

.content-loading {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 200px;
}

:host ::ng-deep .content-body.markdown-body {
    width: 100%;
    background: #ffffff;
    border-radius: 10px;
    padding: 36px 40px;
    box-shadow: 0 1px 6px rgba(0, 0, 0, 0.08);
}

@media (max-width: 768px) {
    :host ::ng-deep .content-body.markdown-body {
        padding: 20px 18px;
    }
}

:host ::ng-deep .content-body.markdown-body h1 {
    font-size: 1.65rem;
    font-weight: 700;
    color: #1e2a3a;
    margin-bottom: 0.5rem;
    padding-bottom: 0.5rem;
    border-bottom: 2px solid #e4e9f0;
}

:host ::ng-deep .content-body.markdown-body h2 {
    font-size: 1.25rem;
    font-weight: 600;
    color: #1e2a3a;
    margin-top: 1.75rem;
    margin-bottom: 0.6rem;
    text-align: left;
}

:host ::ng-deep .content-body.markdown-body h3 {
    font-size: 1.05rem;
    font-weight: 600;
    color: #2c3e5a;
    margin-top: 1.25rem;
    text-align: left;
}

:host ::ng-deep .content-body.markdown-body p {
    font-size: 0.95rem;
    line-height: 1.75;
    color: #3d4f65;
    margin-bottom: 1rem;
}

:host ::ng-deep .content-body.markdown-body ul,
:host ::ng-deep .content-body.markdown-body ol {
    padding-left: 1.4rem;
    margin-bottom: 1rem;
}

:host ::ng-deep .content-body.markdown-body ul li,
:host ::ng-deep .content-body.markdown-body ol li {
    font-size: 0.95rem;
    line-height: 1.7;
    color: #3d4f65;
    margin-bottom: 0.3rem;
}

:host ::ng-deep .content-body.markdown-body a {
    color: #0055b3;
    text-decoration: none;
}

:host ::ng-deep .content-body.markdown-body a:hover {
    text-decoration: underline;
}

:host ::ng-deep .content-body.markdown-body img {
    max-width: 100%;
    width: 100%;
    height: auto;
    border-radius: 8px;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.12);
    margin: 1rem 0;
    display: block;
}

:host ::ng-deep .content-body.markdown-body hr {
    border: none;
    border-top: 1px solid #e4e9f0;
    margin: 1.5rem 0;
}

:host ::ng-deep .content-body.markdown-body code {
    background: #f0f4f8;
    padding: 2px 6px;
    border-radius: 4px;
    font-size: 0.875rem;
    color: #c0392b;
}

:host ::ng-deep .content-body.markdown-body pre {
    background: #f0f4f8;
    padding: 14px 18px;
    border-radius: 8px;
    overflow-x: auto;
    margin-bottom: 1rem;
}

:host ::ng-deep .content-body.markdown-body pre code {
    background: none;
    padding: 0;
    color: #2c3e50;
}

:host ::ng-deep .content-body.markdown-body blockquote {
    border-left: 4px solid #0055b3;
    margin: 1rem 0;
    padding: 8px 16px;
    background: #f0f6ff;
    color: #2c3e5a;
    border-radius: 0 6px 6px 0;
}`, "",{"version":3,"sources":["webpack://./projects/ai_modernization/src/app/user-guide/user-guide.component.css"],"names":[],"mappings":"AAAA;IACI,cAAc;AAClB;;AAEA,iBAAiB;AACjB;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA,YAAY;AACZ;IACI,aAAa;IACb,sBAAsB;IACtB,YAAY;IACZ,gBAAgB;IAChB,mBAAmB;IACnB,cAAc;IACd,yCAAyC;IACzC,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,uBAAuB;IACvB,iDAAiD;IACjD,8BAA8B;IAC9B,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,OAAO;IACP,kBAAkB;IAClB,gBAAgB;IAChB,sBAAsB;IACtB,yBAAyB;IACzB,cAAc;IACd,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA,gBAAgB;AAChB;IACI,OAAO;IACP,gBAAgB;IAChB,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,qCAAqC;IACrC,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,kBAAkB;IAClB,gBAAgB;IAChB,YAAY;IACZ,kCAAkC;IAClC,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;IAChB,mDAAmD;AACvD;;AAEA;IACI,qCAAqC;IACrC,cAAc;AAClB;;AAEA;IACI,kCAAkC;IAClC,0BAA0B;IAC1B,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,iBAAiB;IACjB,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA,kBAAkB;AAClB;IACI,OAAO;IACP,kBAAkB;IAClB,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI;QACI,kBAAkB;IACtB;AACJ;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;IAClB,yCAAyC;AAC7C;;AAEA;IACI;QACI,kBAAkB;IACtB;AACJ;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;IACd,qBAAqB;IACrB,sBAAsB;IACtB,gCAAgC;AACpC;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;IACd,mBAAmB;IACnB,qBAAqB;IACrB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;IACd,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;IACjB,cAAc;IACd,mBAAmB;AACvB;;AAEA;;IAEI,oBAAoB;IACpB,mBAAmB;AACvB;;AAEA;;IAEI,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,eAAe;IACf,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,0CAA0C;IAC1C,cAAc;IACd,cAAc;AAClB;;AAEA;IACI,YAAY;IACZ,6BAA6B;IAC7B,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,UAAU;IACV,cAAc;AAClB;;AAEA;IACI,8BAA8B;IAC9B,cAAc;IACd,iBAAiB;IACjB,mBAAmB;IACnB,cAAc;IACd,0BAA0B;AAC9B","sourcesContent":[":host {\n    display: block;\n}\n\n/* Layout shell */\n.user-guide-layout {\n    display: flex;\n    background: #f4f6f9;\n}\n\n/* Sidebar */\n.user-guide-sidebar {\n    display: flex;\n    flex-direction: column;\n    width: 260px;\n    min-width: 260px;\n    background: #1e2a3a;\n    color: #d6e0ed;\n    box-shadow: 2px 0 8px rgba(0, 0, 0, 0.18);\n    flex-shrink: 0;\n}\n\n.sidebar-header {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    padding: 18px 12px 14px;\n    border-bottom: 1px solid rgba(255, 255, 255, 0.1);\n    background: rgba(0, 0, 0, 0.2);\n    white-space: nowrap;\n    overflow: hidden;\n}\n\n.sidebar-header-icon {\n    color: #6fb3f5;\n    font-size: 22px;\n    flex-shrink: 0;\n}\n\n.sidebar-header-title {\n    flex: 1;\n    font-size: 0.85rem;\n    font-weight: 700;\n    letter-spacing: 0.06em;\n    text-transform: uppercase;\n    color: #ffffff;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n}\n\n/* Sidebar nav */\n.sidebar-nav {\n    flex: 1;\n    overflow-y: auto;\n    overflow-x: hidden;\n    padding: 8px 0;\n}\n\n.sidebar-nav::-webkit-scrollbar {\n    width: 4px;\n}\n\n.sidebar-nav::-webkit-scrollbar-thumb {\n    background: rgba(255, 255, 255, 0.15);\n    border-radius: 2px;\n}\n\n.sidebar-nav-item {\n    display: flex;\n    align-items: center;\n    width: 100%;\n    padding: 11px 14px;\n    background: none;\n    border: none;\n    border-left: 3px solid transparent;\n    cursor: pointer;\n    color: #d6e0ed;\n    text-align: left;\n    white-space: nowrap;\n    overflow: hidden;\n    transition: background 0.22s ease, color 0.22s ease;\n}\n\n.sidebar-nav-item:hover {\n    background: rgba(255, 255, 255, 0.07);\n    color: #ffffff;\n}\n\n.sidebar-nav-item.active {\n    background: rgba(0, 85, 179, 0.35);\n    border-left-color: #0055b3;\n    color: #ffffff;\n}\n\n.sidebar-nav-label {\n    font-size: 0.875rem;\n    line-height: 1.35;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n}\n\n/* Content panel */\n.user-guide-content {\n    flex: 1;\n    padding: 32px 40px;\n    background: #f4f6f9;\n    min-width: 0;\n}\n\n@media (max-width: 768px) {\n    .user-guide-content {\n        padding: 20px 16px;\n    }\n}\n\n.content-loading {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    height: 200px;\n}\n\n:host ::ng-deep .content-body.markdown-body {\n    width: 100%;\n    background: #ffffff;\n    border-radius: 10px;\n    padding: 36px 40px;\n    box-shadow: 0 1px 6px rgba(0, 0, 0, 0.08);\n}\n\n@media (max-width: 768px) {\n    :host ::ng-deep .content-body.markdown-body {\n        padding: 20px 18px;\n    }\n}\n\n:host ::ng-deep .content-body.markdown-body h1 {\n    font-size: 1.65rem;\n    font-weight: 700;\n    color: #1e2a3a;\n    margin-bottom: 0.5rem;\n    padding-bottom: 0.5rem;\n    border-bottom: 2px solid #e4e9f0;\n}\n\n:host ::ng-deep .content-body.markdown-body h2 {\n    font-size: 1.25rem;\n    font-weight: 600;\n    color: #1e2a3a;\n    margin-top: 1.75rem;\n    margin-bottom: 0.6rem;\n    text-align: left;\n}\n\n:host ::ng-deep .content-body.markdown-body h3 {\n    font-size: 1.05rem;\n    font-weight: 600;\n    color: #2c3e5a;\n    margin-top: 1.25rem;\n    text-align: left;\n}\n\n:host ::ng-deep .content-body.markdown-body p {\n    font-size: 0.95rem;\n    line-height: 1.75;\n    color: #3d4f65;\n    margin-bottom: 1rem;\n}\n\n:host ::ng-deep .content-body.markdown-body ul,\n:host ::ng-deep .content-body.markdown-body ol {\n    padding-left: 1.4rem;\n    margin-bottom: 1rem;\n}\n\n:host ::ng-deep .content-body.markdown-body ul li,\n:host ::ng-deep .content-body.markdown-body ol li {\n    font-size: 0.95rem;\n    line-height: 1.7;\n    color: #3d4f65;\n    margin-bottom: 0.3rem;\n}\n\n:host ::ng-deep .content-body.markdown-body a {\n    color: #0055b3;\n    text-decoration: none;\n}\n\n:host ::ng-deep .content-body.markdown-body a:hover {\n    text-decoration: underline;\n}\n\n:host ::ng-deep .content-body.markdown-body img {\n    max-width: 100%;\n    width: 100%;\n    height: auto;\n    border-radius: 8px;\n    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.12);\n    margin: 1rem 0;\n    display: block;\n}\n\n:host ::ng-deep .content-body.markdown-body hr {\n    border: none;\n    border-top: 1px solid #e4e9f0;\n    margin: 1.5rem 0;\n}\n\n:host ::ng-deep .content-body.markdown-body code {\n    background: #f0f4f8;\n    padding: 2px 6px;\n    border-radius: 4px;\n    font-size: 0.875rem;\n    color: #c0392b;\n}\n\n:host ::ng-deep .content-body.markdown-body pre {\n    background: #f0f4f8;\n    padding: 14px 18px;\n    border-radius: 8px;\n    overflow-x: auto;\n    margin-bottom: 1rem;\n}\n\n:host ::ng-deep .content-body.markdown-body pre code {\n    background: none;\n    padding: 0;\n    color: #2c3e50;\n}\n\n:host ::ng-deep .content-body.markdown-body blockquote {\n    border-left: 4px solid #0055b3;\n    margin: 1rem 0;\n    padding: 8px 16px;\n    background: #f0f6ff;\n    color: #2c3e5a;\n    border-radius: 0 6px 6px 0;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
